module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_3.b58cb4a5.png";